/** Türkçe fiyat biçimi — örn. 264.6 → "264,60 TL". Sunucu + istemcide güvenli. */
export function formatTL(n: number): string {
  return (
    n.toLocaleString("tr-TR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) + " TL"
  );
}
